import React from "react";
import { useNavigate } from "react-router-dom";

import ScoutSignUpPage from "../../components/auth/ScoutSignUpPage";
import { useAuth } from "../../context/AuthContext";

const ScoutSignupRoute = () => {
  const navigate = useNavigate();
  const { completeScoutSignup } = useAuth();

  return (
    <ScoutSignUpPage
      onSignUpComplete={() => {
        completeScoutSignup();
        navigate("/scout/dashboard", { replace: true });
      }}
      onGoToLogin={() => navigate("/login")}
      onChangeAccountType={() => navigate("/signup")}
    />
  );
};

export default ScoutSignupRoute;
